import { Card, CardContent } from '@design-system/Card';
import { List, ListItem } from '@design-system/List';
import { Link } from '@design-system/Link';
import type { SubscriptionStatus } from '@viome/viome-base/src/usecase/SMP/SMP.model';
import { isSubscriptionActiveState } from '../utils/smpHelpers';
import {
  SMP_FUTURE_ORDERS_PATH,
  SMP_ORDER_HISTORY_PATH,
} from '@/constants/paths';

interface SMPLandingPageOrdersProps {
  subscriptionStatus: SubscriptionStatus;
}

export const SMPLandingPageOrders = ({
  subscriptionStatus,
}: SMPLandingPageOrdersProps) => {
  const isActiveState = isSubscriptionActiveState(subscriptionStatus);

  return (
    <div className="flex flex-col gap-6" data-testid="smp-orders-section">
      <h2
        className="typography-h2 text-primary px-1"
        data-testid="smp-orders-title"
      >
        Orders
      </h2>

      <Card data-testid="smp-orders-card">
        <CardContent className="p-0" data-testid="smp-orders-content">
          <List data-testid="smp-orders-list">
            {isActiveState && (
              <ListItem asChild data-testid="smp-orders-futureOrders">
                <Link to={SMP_FUTURE_ORDERS_PATH}>Future Orders</Link>
              </ListItem>
            )}

            <ListItem asChild data-testid="smp-orders-orderHistory">
              <Link to={SMP_ORDER_HISTORY_PATH}>Order History</Link>
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </div>
  );
};
